import type { Locale } from "./config";

export function setLocaleAction(locale: Locale) {
  localStorage.setItem("edaga.locale", locale);
  window.location.reload();
}
